import { MS_IN_DAY } from '../../../utils/time-utils';
import type { RefillParamsModifier } from '../../boardMVC/models/tray/RefillMiddleware';

interface MacroBalancingConfig {
  resetTime: number;
  tiers: { range: { min: number; max: number }; minGoalProgress: number; modifier: RefillParamsModifier }[];
}

export const macroBalancingConfig: MacroBalancingConfig = {
  resetTime: MS_IN_DAY * 2,
  tiers: [
    {
      range: { min: 0, max: 0 },
      minGoalProgress: 0.3,
      modifier: {
        maxColors: { offset: -1, minValue: 1 },
        minFill: { offset: 2, maxValue: 6 },
        maxFill: { offset: 2, maxValue: 8 },
      },
    },
    {
      range: { min: 7, max: 12 },
      minGoalProgress: 0.3,
      modifier: {
        maxColors: { offset: 1, maxValue: 4 },
        minFill: { offset: -1, minValue: 1 },
      },
    },
    {
      range: { min: 13, max: Infinity },
      minGoalProgress: 0.3,
      modifier: {
        maxColors: { offset: 1, maxValue: 4 },
        minFill: { offset: -2, minValue: 1 },
        maxFill: { offset: -1, minValue: 2 },
      },
    },
  ],
};
